import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const POLICIES = [
  { label: "FAQ", to: "/policy/faq" },
  { label: "Privacy Policy", to: "/policy/privacy" },
  { label: "Return & Exchange", to: "/policy/returns" },
  { label: "Shipping & Logistics", to: "/policy/shipping" },
  { label: "Terms & Conditions", to: "/policy/terms" },
  { label: "Contact Us", to: "/policy/contact" },
];
const SHOP = [
  { label: "Kurtis & Tunics", to: "/shop?category=Kurtis%20%26%20Tunics" },
  { label: "Suit Sets", to: "/shop?category=Suit%20Sets" },
  { label: "Anarkalis", to: "/shop?category=Anarkalis" },
  { label: "Fusion Dresses", to: "/shop?category=Fusion%20Dresses" },
  { label: "Track Your Order", to: "/track" },
];

export default function Footer() {
  const [ig, setIg] = React.useState("");
  React.useEffect(() => { import("@/lib/api").then(({ api }) => api.get("/config").then((r) => setIg(r.data.instagram || "")).catch(() => {})); }, []);
  return (
    <footer className="bg-rose-950 text-amber-50 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <span className="font-serif text-2xl font-bold">MILLION<span className="text-amber-500"> PIXELS</span></span>
          <p className="text-sm text-amber-50/70 mt-3 leading-relaxed">Contemporary ethnic elegance inspired by Indian craftsmanship. Handpicked kurtis, suit sets & anarkalis delivered pan-India.</p>
          <div className="flex gap-3 mt-5">
            <a href={ig || "#"} target="_blank" rel="noreferrer" className="w-12 h-12 rounded-full border border-amber-50/25 flex items-center justify-center hover:bg-amber-600 hover:border-amber-600 transition-colors" data-testid="social-instagram"><Instagram className="w-5 h-5" /></a>
          </div>
        </div>
        <div>
          <h4 className="accent-label !text-amber-500 mb-4">Shop</h4>
          <ul className="space-y-2.5">{SHOP.map((s) => <li key={s.label}><Link to={s.to} className="text-sm text-amber-50/70 hover:text-amber-50">{s.label}</Link></li>)}</ul>
        </div>
        <div>
          <h4 className="accent-label !text-amber-500 mb-4">Policies</h4>
          <ul className="space-y-2.5">{POLICIES.map((s) => <li key={s.label}><Link to={s.to} className="text-sm text-amber-50/70 hover:text-amber-50" data-testid={`footer-${s.to.split("/").pop()}`}>{s.label}</Link></li>)}</ul>
        </div>
        <div>
          <h4 className="accent-label !text-amber-500 mb-4">Stay Connected</h4>
          <p className="text-sm text-amber-50/70">Get order updates instantly on WhatsApp. Login with your mobile number for a seamless experience.</p>
          <Link to="/login" className="inline-block mt-4 bg-amber-600 text-white px-5 py-2.5 rounded-full text-sm font-accent font-semibold hover:bg-amber-700 transition-colors" data-testid="footer-login-btn">Login / Create Account</Link>
        </div>
      </div>
      <div className="border-t border-amber-50/10 py-5 text-center text-xs text-amber-50/50">
        © 2026 Million Pixels · millionpixel.in · All rights reserved
      </div>
    </footer>
  );
}
